import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

import {
  TXTWCL_To_find_out_moreX_visit_our_Xa_ELL,
  TXTWCL_We_use_electronic_identity_ver_ELL
} from './HelpSectionVerification.messages.json';

const getResolverTag = (siteID: Sites) => {
  switch (true) {
    case siteID === Sites.POR:
      return ResolverTag.PortugueseAccountValidation;
    case siteID === Sites.SPA:
      return ResolverTag.SpanishAccountValidation;
    case siteID === Sites.BEL:
      return ResolverTag.BelgiumAccountValidation;
    case siteID === Sites.DE:
      return ResolverTag.GermanAccountValidation;
    case siteID === Sites.CA_ON:
      return ResolverTag.CanadianAccountValidation;
    case siteID === Sites.ROM:
      return ResolverTag.RomanianAccountValidation;
    case siteID === Sites.UK:
      return ResolverTag.EnglishAccountValidation;
    case siteID === Sites.FRA:
      return ResolverTag.FrenchAccountValidation;
    default:
      return ResolverTag.CustomerVerificationProcess;
  }
};

const HelpSectionVerification: React.FC = () => {
  const site = useSelector(select.cms.getSiteId);

  return (
    <>
      <Translation {...TXTWCL_We_use_electronic_identity_ver_ELL} />{' '}
      <Translation
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={getResolverTag(site)}>{msg}</ResolverLink>
          )
        }}
        {...TXTWCL_To_find_out_moreX_visit_our_Xa_ELL}
      />
    </>
  );
};

export default HelpSectionVerification;
